import { render, staticRenderFns } from "./DirectChannels.html?vue&type=template&id=939dde7c&scoped=true&"
import script from "./DirectChannels.js?vue&type=script&lang=js&"
export * from "./DirectChannels.js?vue&type=script&lang=js&"
import style0 from "./DirectChannels.scss?vue&type=style&index=0&id=939dde7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939dde7c",
  null
  
)

export default component.exports